// deps
import React, { memo } from "react";

//types
import { ITurboPaymentMethodProps } from "@payment-ui/interfaces";

//components
import TurboPaymentMethodWidgetV2 from "./v2";
import TurboPaymentMethodWidget from "./TurboPaymentMethodWidget";

function TurboPaymentMethodWrapper(props: ITurboPaymentMethodProps) {
    const { isTurboV2 = false } = props;

    if (isTurboV2) {
        return <TurboPaymentMethodWidgetV2 {...props} />;
    }

    return <TurboPaymentMethodWidget {...props} />;
}
export default memo(TurboPaymentMethodWrapper);
